import { useCallback, useMemo } from 'react';
import countryStates from 'static/states.json';
import useI18n from '../useI18n';

const useCountryStates = () => {
  const { country } = useI18n();
  const states = useMemo(() => countryStates[country as keyof typeof countryStates] ?? [], [country]);

  const stateCodeToStateName = useCallback(
    (code: string) => states.find((state) => state.code === code)?.code,
    [states],
  );

  return {
    states,
    stateCodeToStateName,
  };
};

export default useCountryStates;
